<template>
  <v-container>
    <ContentHeader
      header-icon="mdi-clipboard-text-clock"
      header-title="Enrollment Due Date"
      back-navigation
      back-navigation-href="/admin"
      back-navigation-text="To Old Admin"
    >
    </ContentHeader>
    <PtSheet class="main-content">
      <template v-if="success">
        <div class="text-center employees-upload-success">
          <v-icon style="margin-bottom: 56px">$employeeUploadSuccess</v-icon>
          <p>
            The file has been uploaded
          </p>
          <yellow-button @click="reset">Reset</yellow-button>
        </div>
      </template>
      <template v-else>
        <v-card-title>
          <h3 class="s">Upload file</h3>
        </v-card-title>
        <div class="mb-2">
          Please upload a file with a header row, and columns in this order
          <ol>
            <li>COV ID</li>
            <li>Enrollment due date (MM/DD/YYYY)</li>
          </ol>
        </div>
        <div class="d-flex justify-space-between">
          <file-upload-dnd
            class="flex-grow-1"
            :accepted-files="{
              CSV: 'text/csv'
            }"
            :dropzone-options="dropzoneOptions"
            title="Upload File"
            @input="fileId = $event"
          >
          </file-upload-dnd>
        </div>

        <div class="text-right mt-8">
          <v-btn
            class="mb-4"
            depressed
            color="primary"
            @click="uploadFile()"
            :block="$vuetify.breakpoint.xsOnly"
            :disabled="!fileId"
          >
            Upload File
          </v-btn>
        </div>
      </template>
    </PtSheet>
  </v-container>
</template>

<script>
import FileUploadDnd from "@/components/FileUploadDnd";
import { post } from "@/services/request";
import hasNotifications from "@/mixins/has-notifications";
import hasCurrentUser from "@/mixins/has-current-user";
import { enrollmentDueDateUploadAPI } from "@/services/api";
import YellowButton from "@/components/providertrust/buttons/SmallYellowButton";
import PtSheet from "@/components/PtSheet.vue";
import ContentHeader from "@/views/ContentHeader.vue";

const dropzoneOptions = {
  url: "/services/files",
  headers: {
    "user-type": "admin",
    "directory-name": "enrollment-due-date"
  }
};

export default {
  name: "EnrollmentDueDateImport",

  mixins: [hasCurrentUser, hasNotifications],
  components: {
    ContentHeader,
    PtSheet,
    FileUploadDnd,
    YellowButton
  },

  data() {
    return {
      fileId: null,
      dropzoneOptions,
      success: false
    };
  },
  created() {},
  computed: {},
  methods: {
    reset() {
      this.fileId = null;
      this.success = false;
    },
    uploadFile() {
      const fileId = this.fileId;

      post(enrollmentDueDateUploadAPI, {
        fileId
      }).then(
        () => {
          console.log("File uploaded successfully, fileId: ", fileId);

          this.reset();
          this.success = true;
        },
        error => {
          console.error("File upload failed, fileId: ", fileId);

          if (!error.response || error.response.status === 500) {
            this.showMessage({
              mode: "error",
              text: "Unknown error. Please try again later"
            });
          } else {
            this.showMessage({
              mode: "error",
              text:
                "Invalid file. Please upload a file with columns in this order: cov id, date (MM/DD/YYYY)"
            });
          }
        }
      );
    }
  }
};
</script>
